import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { DisciplineType } from "@type/HRM/discipline";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}`;

export const createDiscipline = (() => {
  return async (data: { data: any }): Promise<{ data: any }> => {
    const { employeeID, ...rest } = data.data;

    return api
      .post(
        `${apiEndPoint}/${employeeID}/discipline-info/disciplinary-actions`,
        {
          ...rest,
        },
      )
      .then((response) => ({ data: response.data }));
  };
})();

export const updateDiscipline = (() => {
  return async (data: { data: any }): Promise<{ data: any }> => {
    const { employeeID, disciplineId, ...rest } = data.data;

    return api
      .put(
        `${apiEndPoint}/${employeeID}/discipline-info/disciplinary-actions/${disciplineId}`,
        {
          ...rest,
        },
      )
      .then((response) => ({ data: response.data }));
  };
})();

export const getDisciplines = (() => {
  return async (employeeID: string): Promise<{ data: DisciplineType }> => {
    return api
      .get(`${apiEndPoint}/${employeeID}/discipline-info`)
      .then((response) => ({ data: response.data.disciplines }));
  };
})();

export const deleteDisciplineTable = (() => {
  return async (data: { data: any }): Promise<{ data: any }> => {
    const { disciplineID, employeeID } = data.data;

    return api
      .delete(
        `${apiEndPoint}/${employeeID}/discipline-info/disciplinary-actions/${disciplineID}`,
      )
      .then((response) => ({ data: disciplineID }));
  };
})();
